export enum UserRoleInShop {
  owner = 'owner',
  employee = 'employee'
}
